import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    min: { type: Number, default: 0 },
    max: { type: Number, default: 9999 },
    stripLeadingZeros: { type: Boolean, default: false }
  }

  connect() {
    this.enforceConstraints()
  }

  input(event) {
    this.enforceConstraints()
  }

  keydown(event) {
    if (['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'].includes(event.key)) {
      return
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault()
      return
    }

    const currentValue = this.element.value || '0'
    const cursorPosition = this.element.selectionStart
    const cursorEnd = this.element.selectionEnd
    const beforeCursor = currentValue.substring(0, cursorPosition)
    const afterCursor = currentValue.substring(cursorEnd)
    const potentialValue = parseInt(beforeCursor + event.key + afterCursor, 10)

    if (potentialValue > this.maxValue) {
      event.preventDefault()
    }
  }

  enforceConstraints() {
    if (this.element.value === null || this.element.value === '') {
      return
    }

    const cursorPosition = this.element.selectionStart
    const oldLength = this.element.value.length

    let value = this.element.value.replace(/\D/g, '')

    if (value === '') {
      this.element.value = ''
      return
    }

    // Leading zeros are significant for some NUMERICAL fields (e.g., flight number "0009")
    // even though they're not mathematically significant for NUMBERS
    if (this.stripLeadingZerosValue) {
      value = value.replace(/^0+/, '')
      if (value === '') {
        value = '0'
      }
    }

    let numValue = parseInt(value, 10)

    if (numValue < this.minValue) {
      numValue = this.minValue
      value = numValue.toString()
    } else if (numValue > this.maxValue) {
      numValue = this.maxValue
      value = numValue.toString()
    }

    const newValue = value
    this.element.value = newValue

    const newLength = newValue.length
    const lengthDiff = newLength - oldLength
    let newCursorPosition = cursorPosition + lengthDiff
    newCursorPosition = Math.min(newCursorPosition, newLength)
    newCursorPosition = Math.max(0, newCursorPosition)
    this.element.setSelectionRange(newCursorPosition, newCursorPosition)
  }

  paste(event) {
    event.preventDefault()
    const pastedText = event.clipboardData.getData('text')
    let cleaned = pastedText.replace(/\D/g, '')

    if (cleaned) {
      const numValue = Math.min(this.maxValue, Math.max(this.minValue, parseInt(cleaned, 10)))

      if (this.stripLeadingZerosValue) {
        this.element.value = numValue.toString()
      } else {
        if (numValue === parseInt(cleaned, 10)) {
          this.element.value = cleaned
        } else {
          this.element.value = numValue.toString()
        }
      }
    }
  }
}
